import styled from "styled-components";

export const TextCheckContainer = styled.div`
  display: flex;
  align-items: center;
  grid-gap: ${({ gridGap }) => gridGap || ""};
`;
